export const billingKeys = {
  all: ['billing'] as const,
  data: (companyId: string) => [...billingKeys.all, 'data', companyId] as const,
  mutations: () => [...billingKeys.all, 'mutations'] as const,
} as const;
